import { render, staticRenderFns } from "./cardInfoPaciente.vue?vue&type=template&id=43423ffa&scoped=true"
import script from "./cardInfoPaciente.vue?vue&type=script&lang=js"
export * from "./cardInfoPaciente.vue?vue&type=script&lang=js"
import style0 from "./cardInfoPaciente.vue?vue&type=style&index=0&id=43423ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43423ffa",
  null
  
)

export default component.exports